export default
{
	availableUnits: 10,
	score: {
		min: 4,
		max: 8,
        displayMax: 11
	},
	name: "delier4",
	day: 2,
	date: {
		time: "09:33",
		day: "scene.date.text" 
	},
	patientState: 0,
	delirium: {
		initialState: "rood",
		clockPosition: {
			x: 774,
			y: 180
		},
		videoUrls: [
			{
				whiteboardState: 0,
				blindsState: 0,
				url: "delier4/${locale}/delier_4_nacht_ochtend_blinds-dicht.flv"
			},
			{
				whiteboardState: 1,
				blindsState: 0,
				url: "delier4/${locale}/delier_4_nacht_ochtend_blinds-dicht_ma.flv"
			},
			{
				whiteboardState: 2,
				blindsState: 0,
				url: "delier4/${locale}/delier_4_nacht_ochtend_blinds-dicht_di.flv"
			}
		],
		roomViewToggleButtonPosition: {
			x: 1381,
			y: 335
		}
	},
	room: {
		backgroundImage: {
			blindsOpenUrl: "delier4/delier4_nurseview_room_blinds_open.jpg",
			blindsClosedUrl: "delier4/delier4_nurseview_room_blinds_closed.jpg"
		},
		clock: {
			blindsOpenUrl: "delier4/delier4_nurseview_room_blinds_open_klok.png",
			blindsClosedUrl: "delier4/delier4_nurseview_room_blinds_closed_klok.png"
		}
	},
	end: {
		clockPosition: {
			x: 776,
			y: 183
		},
		videoUrls: [
			{
				whiteboardState: 0,
				blindsState: 0,
				url: "delier4/${locale}/delier_4_slot_blinds_dicht.flv"
			},
			{
				whiteboardState: 1,
				blindsState: 0,
				url: "delier4/${locale}/delier_4_slot_blinds_dicht_ma.flv"
			},
			{
				whiteboardState: 2,
				blindsState: 0,
				url: "delier4/${locale}/delier_4_slot_blinds_dicht_di.flv"
			},
			{
				whiteboardState: 3,
				blindsState: 0,
				url: "delier4/${locale}/delier_4_slot_blinds_dicht_wo.flv"
			},
			{
				whiteboardState: 0,
				blindsState: 1,
				url: "delier4/${locale}/delier_4_slot_blinds_open.flv"
			},
			{
				whiteboardState: 1,
				blindsState: 1,
				url: "delier4/${locale}/delier_4_slot_blinds_open_ma.flv"
			},
			{
				whiteboardState: 2,
				blindsState: 1,
				url: "delier4/${locale}/delier_4_slot_blinds_open_di.flv"
			},
			{
				whiteboardState: 3,
				blindsState: 1,
				url: "delier4/${locale}/delier_4_slot_blinds_open_wo.flv"
			}
		]
	},
	transitions: [
		{
			deliriumState: "oranje",
			target: "delier6"
		},
		{
			deliriumState: "rood",
			target: "delier7"
		},
		{
			deliriumState: "zwart",
			target: "delier7"
		}
	],
	mediaUrls: [
		{
			categoryName: "communiceren",
			value: "delier4/${locale}/delier_4_dialoog_startloop.flv"
		},
		{
			categoryName: "communiceren",
			actionName: "patientlatenslapen",
			value: "delier4/${locale}/delier_4_dialoog_latenslapen.flv"
		},
		{
			categoryName: "communiceren",
			actionName: "artsaanpatientvoorstellen",
			value: "delier4/${locale}/delier_4_dialoog_benoemenaanwzigheid.flv"
		},
		{
			categoryName: "communiceren",
			actionName: "vragenwatdepatientheeftgezien",
			value: "delier4/${locale}/delier_4_dialoog_doorvrhallucinatie.flv"
		},
		{
			categoryName: "communiceren",
			actionName: "vragenofdepatientweetwaarhijis",
			value: "delier4/${locale}/delier_4_dialoog_doorvrorientatie.flv"
		},
		{
			categoryName: "communiceren",
			actionName: "afrondenenkamerverlaten",
			value: "delier4/${locale}/delier_4_dialoog_dag.flv"
		}
	]
}